import { render, staticRenderFns } from "./ClientSelect.vue?vue&type=template&id=bca52f0a&scoped=true"
import script from "./ClientSelect.vue?vue&type=script&lang=js"
export * from "./ClientSelect.vue?vue&type=script&lang=js"
import style0 from "./ClientSelect.vue?vue&type=style&index=0&id=bca52f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca52f0a",
  null
  
)

export default component.exports